export * as tags from '@wix/auto_sdk_tags_tags/schemas';
